import { CanActivateViaAuthGuard } from './../bz-authentication/bz-can-activate-auth';
import { Routes } from '@angular/router';
import { menus } from '../core/models/constants';
import { DataVisualizationComponent } from './datavisualization.component';
import { TableauComponent } from './dv-tableau/dv-tableau.component';

export const RoutesDataVisualization: Routes = [
    {
        path: menus.PowerBI.path,
        component: DataVisualizationComponent,
        data: { title : menus.PowerBI.title },
        canActivate: [CanActivateViaAuthGuard]
    },
    {
        path: menus.Tableau.path,
        component: TableauComponent,
        data: { title : menus.Tableau.title },
        canActivate: [CanActivateViaAuthGuard]
    }
];
